import React from "react";
import { useLang } from "../context/LanguageContext";
import useReveal from "../hooks/useReveal";
import { Building2, Warehouse, ShoppingBag, Briefcase, HardHat } from "lucide-react";

const ICONS = [Building2, Warehouse, ShoppingBag, Briefcase, HardHat];

export default function Sectors() {
  const { t } = useLang();
  const s = t.sectors;
  const ref = useReveal();

  return (
    <section className="bg-white py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="section-line" />
            <span className="text-xs font-700 uppercase tracking-[0.25em] font-display text-[#f5871f]">
              {s.eyebrow}
            </span>
            <span className="section-line" />
          </div>
          <h2 className="font-display font-700 text-3xl md:text-4xl uppercase text-[#0d2140]">{s.title}</h2>
        </div>

        <div ref={ref} className="reveal mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {s.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={i}
                className="card-hover flex flex-col items-center text-center gap-3 rounded-2xl border border-[#0d2140]/10 bg-[#f4f6f9] px-4 py-7 hover:border-[#f5871f]/40"
              >
                <Icon className="w-8 h-8 text-[#f5871f]" />
                <span className="text-sm font-600 text-[#0d2140] leading-snug">{item}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
